import { render, staticRenderFns } from "./DoctorEditModal.vue?vue&type=template&id=664f3a2c&scoped=true"
import script from "./DoctorEditModal.vue?vue&type=script&lang=js"
export * from "./DoctorEditModal.vue?vue&type=script&lang=js"
import style0 from "./DoctorEditModal.vue?vue&type=style&index=0&id=664f3a2c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "664f3a2c",
  null
  
)

export default component.exports